import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getUserDetailUrl } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
export const UserActionMenu = ({ id }) => {
  const isReadOnly = useAccess(FEATURE.USERS, "R");
  const hasEditAccess = useAccess(FEATURE.USERS, "U");
  const hasDeleteAccess = useAccess(FEATURE.USERS, "D");
  const { mutate } = useMutate("users");
  const onDelete = useCallback(() => {
    mutate({ url: getUserDetailUrl(id), method: "DELETE" });
  }, [id, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
